import Login from "@/pages/login";
import Reports from "@/pages/reports";
import AuditedReports from "@/pages/audited-reports";
import Report from "@/pages/report";
import ResetPassword from "@/pages/reset-password";
import Profile from "@/pages/profile";
import Settings from "@/pages/settings";
import React from "react";
import { Navigate, Route, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import useUser from "@/context/user";
import Layout from "@/components/layout";
import AuthLayout from "@/components/auth/layout";
import Verifications from "@/pages/verifications";
import Category from "@/pages/category";
import Organizations from "@/pages/organizations";

const router = createBrowserRouter(
    createRoutesFromElements(
        <React.Fragment>
            <Route
                path="*"
                Component={() => {
                    const authenticated = useUser.getState().authenticated;

                    if (authenticated) return <Navigate to="/reports" />;
                    return <Navigate to="/sign-in" />;
                }}
            />
            <Route element={<AuthLayout />}>
                <Route path="/sign-in" element={<Login />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/organizations" element={<Organizations />} />
            </Route>
            <Route element={<Layout />}>
                <Route path="/profile" element={<Profile />} />
            </Route>
            <Route path="/organizations/:oid" element={<Layout />}>
                <Route path="settings" element={<Settings />} />
                <Route path="reports" element={<Reports />} />
                <Route path="audited-reports" element={<AuditedReports />} />
                <Route
                    path="submissions/:sid/reports/:rid/verifications"
                    element={<Verifications />}
                />
                <Route path="submissions/:sid/reports/:rid" element={<Report />} />
                <Route
                    path="submissions/:sid/reports/:rid/categories-overview"
                    element={<Category />}
                />
            </Route>
        </React.Fragment>,
    ),
);

export default router;
